
export const IDLE= 'idle'
export const SUCCESS= 'success'
export const ERROR= 'error'
export const LOADING= 'loading'

//asset protocl
export const SFTP = "sftp";
export const RDP = "rdp";
export const SSH = "ssh";
export const WEB_APP = "Web App";
export const SMB = "smb";
export const FTP = "ftp";
export const MYSQL = "MySQL";
export const ORACLEDB = "Oracledb";
export const MSSQL = "MSSQL";
export const SAPHANA= 'SAPHanadb'
export const POSTGRESQL = "PostgreSQL";
export const MONGODB = "Mongodb";
export const KUBERNETES = "Kubernetes";

// special symbols
export const SPECIAL_SYMBOLS = "\\-!#$%&()*,./:;?@[]^_`{|}~+<=>";

// default ports
export const DEFAULT_PORTS = {
  [POSTGRESQL]: 5432,
  [MYSQL]: 3306,
  [MSSQL]: 1433,
  [ORACLEDB]: 1521,
  [SAPHANA]: 30015,
  [MONGODB]: 27017,
  [KUBERNETES]: 443,

  // camelCase keys for compatibility with certain UI routes
  postgreSQL: 5432,
  mysql: 3306,
  mssql: 1433,
  oracledb: 1521,
  sapHanadb: 30015,
  mongodb: 27017,
  kubernetes: 443,
};


